import { StudentSocialEmotionalNoteNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentSocialEmotionalNoteNameFragment) {
	return instance.id;
}

export const fieldSetLabels = {
	issueNature: "What is the nature of the issue?",
	solutionRec: "What is your suggested solution?",
};

export const fieldLabels = {
	isIssueNatureLearningDifficulty: "Learning difficulty",
	isIssueNatureAttentionIssue: "Attention issue",
	isIssueNatureFocusIssue: "Focus issue",
	isIssueNatureEmotionalOrVulnerableIssue: "Emotional or vulnerable issue",
	isIssueNatureOther: "Other",
	issueNatureOther: "Describe",
	isSolutionRecDifferentiatedLearning: "Differentiated learning",
	isSolutionRecIndividualLearningPlan: "Individual learning plan (ILP)",
	isSolutionRecTutoring: "Tutoring",
	isSolutionRecProfessionalSupport: "Professional support",
	isSolutionRecInClassSupport: "In-class support",
	isSolutionRecOther: "Other",
	solutionRecOther: "Describe",
};
